import { Button, Tooltip, Upload } from 'antd';
import React, { useState } from 'react';
import { useAssetsUppy } from '@context/AssetsUppyContext';
import LottieComponent from '@components/Lottie';
/* eslint-disable react/no-children-prop */
import { UppyRemotePickerModal } from '@components/Modals/UppyRemotePickerModal/UppyRemotePickerModal';
import { CampaignItemDto } from '@api/Api';
import { BoxIcon, DropboxIcon, GoogleDriveIcon } from '@icons';
import './AssetsEmptyState.less';

function AssetsEmptyState({
  campaign,
  folderId,
  isSearchEmptyState
}: {
  campaign?: CampaignItemDto;
  folderId?: string;
  isSearchEmptyState?: boolean;
}) {
  const uppy = useAssetsUppy();
  const onAddFile = async (data: any) => {
    if (!campaign?.id) return;
    uppy.addFile({
      name: data.file.name,
      type: data.file.type,
      data: data.file,
      meta: {
        relativePath: new Date().toISOString(),
        campaignId: campaign.id,
        folderId: folderId ?? null
      }
    });
    await uppy.upload();
  };
  const [activeRemote, setActiveRemote] = useState<string | null>(null);

  const showUpload =
    !isSearchEmptyState && !!campaign?.permissions.createAssets;
  return showUpload ? (
    <>
      <Upload
        multiple
        showUploadList={false}
        customRequest={(data) => {
          onAddFile(data);
        }}
        className="assets_empty_state_upload_area"
      >
        <div className="assets_empty_state">
          <div className="block">
            <LottieComponent className="icon" view="upload" />

            <p>
              Drag & drop files or folders,{' '}
              <Button
                type="link"
                style={{ padding: 0, textDecoration: 'underline' }}
              >
                browse files
              </Button>{' '}
              or import from:
            </p>
            <div className="block__import" onClick={(e) => e.stopPropagation()}>
              <Tooltip
                placement="bottom"
                overlayClassName="toggle_favorite_overlay toggle_favorite_overlay--small"
                title="Google Drive"
              >
                <Button
                  aria-label="Google Drive"
                  type="ghost"
                  onClick={() => setActiveRemote('GoogleDrive')}
                >
                  <GoogleDriveIcon />
                </Button>
              </Tooltip>
              <Tooltip
                placement="bottom"
                overlayClassName="toggle_favorite_overlay toggle_favorite_overlay--small"
                title="Box"
              >
                <Button
                  aria-label="Box"
                  type="ghost"
                  onClick={() => setActiveRemote('Box')}
                >
                  <BoxIcon className="box-icon" />
                </Button>
              </Tooltip>
              <Tooltip
                placement="bottom"
                overlayClassName="toggle_favorite_overlay toggle_favorite_overlay--small"
                title="Dropbox"
              >
                <Button
                  aria-label="Dropbox"
                  type="ghost"
                  onClick={() => setActiveRemote('Dropbox')}
                >
                  <DropboxIcon />
                </Button>
              </Tooltip>
            </div>
          </div>
        </div>
      </Upload>
      <UppyRemotePickerModal
        uppy={uppy}
        activeRemote={activeRemote}
        onClose={() => setActiveRemote(null)}
        onFilesAdded={(files) => {
          if (!campaign?.id) return;
          for (const file of files || []) {
            file.meta.relativePath = new Date().toISOString();
            file.meta.campaignId = campaign.id;
            file.meta.folderId = folderId;
            uppy.setFileMeta(file.id, file.meta);
          }
          uppy.upload();
        }}
      />
    </>
  ) : (
    <div className="assets_empty_state assets_empty_state--search">
      <div className="block">
        <LottieComponent className="icon" view="noSearchingResult" />
        <strong
          className="main-body-text main-body-text--bold"
          style={{ marginBottom: 8 }}
        >
          No results found
        </strong>
        <p className="main-body-text main-body-text--dark-gray">
          It seems we can’t find any results based on your search
        </p>
      </div>
    </div>
  );
}

export default AssetsEmptyState;
